window.VegasCart = {
	add: function ($self) {
		let $product = $self.closest('[data-cart=product]'),
			id = $product.data('id'),
			cnt = $product.find('input.cnt').val() || 1,
			params = VegasCart.formData({id: id, cnt: cnt});

		$.post('/cart/add_product', params, function (data) {
			if (!data.error) {
				VegasCart.total(data);
				$product.addClass('in-cart');
				yaCounterReachGoal('add-to-cart');
			}
		});
	},

	update: function ($self) {
		let $product = $self.closest('[data-cart=product]'),
			id = $product.data('id'),
			cnt = $product.find('input.cnt').val() || 1,
			params = VegasCart.formData({id: id, data: {cnt: cnt}});

		$.post('/cart/change_product', params, function (data) {
			VegasCart.total(data);
		});

		let price = parseInt($product.find('.price').data('price')),
			total = price * cnt;

		$product.find('.total span').text(output_money(total));
	},

	remove: function ($self) {
		let $product = $self.closest('[data-cart=product]'),
			id = $product.data('id'),
			params = {
				id: id, _token: App.csrf,
			},
			$rows;

		if ($product.hasClass('cart-product')) {
			$rows = parseInt($('[data-cart=product]:visible').length) - 1;
		}

		$.post('/cart/del_product', params, function (data) {
			VegasCart.total(data);

			if ($product.hasClass('cart-product')) {
				$('.cart-product[data-cart="product"][data-id="' + id + '"]').each(function (i, e) {
					$(e).slideUp('fast', function () {
						$(this).remove();
					});
				});
				if ($rows === 0) location.reload();
			} else {
				$product.removeClass('in-cart');
			}
		});
	},

	total: function (data) {
		let $total = $('[data-cart=total]');

		if (typeof data.cart_products !== 'undefined') {
			if (data.cart_products) {
				$total.text(data.cart_products).fadeIn();
			} else {
				$total.fadeOut();
			}
		}

		if (typeof data.cart_totals !== 'undefined') {
			if (typeof data.cart_totals.sum_products !== 'undefined') {
				$("[data-cart][data-counter=sum-products]").text(output_money(data.cart_totals.sum_products));
			}
		}
	},
	totalAll: function () {
		$.get('/cart/get_totals', VegasCart.formData(), function (data) {
			VegasCart.total(data);
		});
	},
	formData: function (rParams, form) {
		let randomParams = rParams || {},
			$form = $('#form-make-order');

		if ($form.length) {
			let params = $form.serializeArray();
			for (let i = 0; i < params.length; i++) {
				randomParams[params[i].name] = params[i].value;
			}
		}

		randomParams['_token'] = App.csrf;

		return randomParams;
	}
};

/**
 * Прослушиватели событий корзины
 **/
$(document).on('click', '[data-cart=add]', function () {
	VegasCart.add($(this));
	$(this).attr('data-cart', 'remove');
	return false;
});

$(document).on('click', '[data-cart=remove]', function () {
	VegasCart.remove($(this));
	$(this).attr('data-cart', 'add');
	return false;
});

$(document).on('click', '[data-toggle=count-items]', function () {
	let $self = $(this),
		sign = $self.data('sign'),
		$container = $self.closest('.count-items'),
		$input = $container.find('input.cnt'),
		max = parseInt($input.attr('max')),
		prevCnt = parseInt($input.val()) || 1,
		cnt = prevCnt
	;

	if (sign === 'minus') {
		if (cnt > 1) {
			cnt--;
		}
	} else {
		if (cnt + 1 <= max) {
			cnt++;
		}
	}

	var $inStock = $container.find('.in-stock');
	if (cnt == max) {
		$inStock.show();
	} else {
		$inStock.hide();
	}

	$input.val(cnt);

	if (cnt != prevCnt) {
		VegasCart.update($self);
	}

	return false;
});